import {Fragment, useState} from 'react';
import {Formik} from "formik";
import * as Yup from "yup";

const Organisation = ({ state, updateState, nextStep, previousStep }) => {
  const [isSeasonal, setIsSeasonal] = useState(state?.data?.trading?.is_seasonal || false);

  return (
    <Formik
      initialValues={{
        employee_count: state?.data?.trading?.employee_count || '',
        pos_count: state?.data?.trading?.pos_count || '',
        tx_per_month: state?.data?.trading?.tx_per_month || '',
        average_value: state?.data?.trading?.average_value || '',
      }}
      validationSchema={Yup.object().shape({
        employee_count: Yup
          .number()
          .min(1, 'Employee count must be at least 1')
          .required('Employee count is required'),
        pos_count: Yup
          .number(),
        tx_per_month: Yup
          .number()
          .min(1, 'Transaction count must be at least 1')
          .required('Transaction count is required'),
        average_value: Yup
          .number()
          .min(1, 'Average Value must be at least £1')
          .max(30000, 'Average transaction Value must not be above £30,000')
          .required('Average Value is required'),
      })}
      onSubmit={async (values, {
        setSubmitting
      }) => {
        setSubmitting(true);
        updateState('trading', {
          ...values,
          is_seasonal: isSeasonal,
        });
        nextStep();
      }}
    >
      {({
          errors,
          handleBlur,
          handleChange,
          handleSubmit,
          isSubmitting,
          touched,
          values,
          setFieldValue,
        }) => (
        <Fragment>
          <form action="#" method="POST" onSubmit={handleSubmit}>

            <h1 className="text-2xl font-semibold mb-6">Trading Information</h1>

            <div className="grid grid-cols-1 gap-x-8 gap-y-6 sm:grid-cols-2">

              <div className="sm:col-span-2 mb-2">
                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-state">
                  How many employees work for your organisation *
                </label>
                <div className="mt-2.5">
                  <input type="number"
                         name="employee_count"
                         id="employee_count"
                         value={values.employee_count}
                         onBlur={handleBlur}
                         onChange={handleChange}
                         placeholder={'e.g. 10'}
                         className={`block appearance-none w-full rounded-md border border-gray-200 text-gray-900 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500${touched.employee_count && errors.employee_count ? ' border-red-500' : ''}`}
                  />
                  {touched.employee_count && errors.employee_count && <div className="field-error">{errors.employee_count}</div>}
                </div>
              </div>

              <div className="gap-x-4 sm:col-span-2">
                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-state">
                  Are you a seasonal business?
                </label>
                <div className="mt-2.5 clear">
                  <ul
                    className="items-center w-full text-sm font-medium text-gray-900 bg-white border rounded-lg sm:flex bg-gray-100 border-gray-300">
                    <li
                      className="w-full border-b border-gray-200 sm:border-b-0 sm:border-r border-gray-300">
                      <div className="flex items-center">
                        <input id="horizontal-list-radio-license" type="radio" value="" name="list-radio" checked={isSeasonal === false} onChange={() => setIsSeasonal(false)}
                               className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-700 dark:focus:ring-offset-gray-700 focus:ring-2 bg-gray-500 border-gray-300" />
                          <label htmlFor="horizontal-list-radio-license"
                                 className="w-full py-3 ml-2 text-sm font-medium text-felloh">No</label>
                      </div>
                    </li>
                    <li
                      className="w-full border-b border-gray-200 sm:border-b-0 sm:border-r border-gray-300">
                      <div className="flex items-center">
                        <input id="horizontal-list-radio-id" type="radio" value="" name="list-radio" checked={isSeasonal === true} onChange={() => setIsSeasonal(true)}
                               className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-700 dark:focus:ring-offset-gray-700 focus:ring-2 dark:bg-gray-600 dark:border-gray-300" />
                          <label htmlFor="horizontal-list-radio-id"
                                 className="w-full py-3 ml-2 text-sm font-medium text-felloh">Yes</label>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>

              <div className="sm:col-span-2 mb-2">
                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-state">
                  How many POS/PDQ machines do you have? *
                </label>
                <div className="mt-2.5">
                  <input type="number"
                         name="pos_count"
                         id="pos_count"
                         value={values.pos_count}
                         onBlur={handleBlur}
                         onChange={handleChange}
                         placeholder={'e.g. 2'}
                         className={`block appearance-none w-full rounded-md border border-gray-200 text-gray-900 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500${touched.pos_count && errors.pos_count ? ' border-red-500' : ''}`}
                  />
                  {touched.pos_count && errors.pos_count && <div className="field-error">{errors.pos_count}</div>}
                </div>
              </div>

              <div className="sm:col-span-2 mb-2">
                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-state">
                  How many transactions do you do per month? *
                </label>
                <div className="mt-2.5">
                  <input type="number"
                         name="tx_per_month"
                         id="tx_per_month"
                         value={values.tx_per_month}
                         onBlur={handleBlur}
                         onChange={handleChange}
                         placeholder={'e.g. 520'}
                         className={`block appearance-none w-full rounded-md border border-gray-200 text-gray-900 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500${touched.tx_per_month && errors.tx_per_month ? ' border-red-500' : ''}`}
                  />
                  {touched.tx_per_month && errors.tx_per_month && <div className="field-error">{errors.tx_per_month}</div>}
                </div>
              </div>

              <div className="sm:col-span-2 mb-2">
                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-state">
                  What is the average GBP value of your transactions? *
                </label>
                <div className="mt-2.5">
                  <div className="flex">
                    <span
                      className="inline-flex items-center px-3 text-sm text-white bg-gray-200 border border-r-0 border-gray-300 rounded-l-md dark:bg-gray-600 dark:border-gray-600 bg-felloh ">
                      £
                    </span>
                    <input type="number"
                           name="average_value"
                           id="average_value"
                           value={values.average_value}
                           onBlur={handleBlur}
                           onChange={handleChange}
                           placeholder={'e.g. 1252'}
                           className={`block appearance-none w-full rounded-md border border-gray-200 text-gray-900 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500${touched.average_value && errors.average_value ? ' border-red-500' : ''}`}
                    />
                  </div>
                  {touched.average_value && errors.average_value && <div className="field-error">{errors.average_value}</div>}

                </div>
              </div>

            </div>

            <div className="mt-12">
              <button type="submit"
                      className="bg-purple-800 disabled:bg-purple-200 hover:bg-purple-900 text-white font-semibold rounded-md py-2 px-4 w-full">
                Next
              </button>
            </div>

            <div className="mt-4">
              <button type="button"
                      onClick={previousStep}
                      className="block w-full rounded-md bg-slate-300 px-3.5 py-2.5 text-center text-md font-semibold text-black shadow-sm hover:text-white hover:bg-slate-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-slate-600">
                Previous
              </button>
            </div>
          </form>
        </Fragment>
      )}
    </Formik>
  );
}

export default Organisation;
